var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlockCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17,8v-1c0-3.86-3.14-7-7-7S3,3.14,3,7v1H0v13c0,1.654,1.346,3,3,3h9.726c-1.667-1.467-2.726-3.61-2.726-6h-1v-4h2.087c1.386-2.386,3.961-4,6.913-4,.692,0,1.359.097,2,.263v-2.263h-3Zm-2,0H5v-1c0-2.757,2.243-5,5-5s5,2.243,5,5v1Zm3,4c-3.314,0-6,2.686-6,6s2.686,6,6,6,6-2.686,6-6-2.686-6-6-6Zm.619,8.414c-.378.378-.88.586-1.414.586h-.002c-.534,0-1.036-.209-1.413-.587l-2.012-2.012,1.414-1.414,2.013,2.013,3.615-3.615,1.414,1.414-3.615,3.615Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockCheck);
export default __webpack_public_path__ + "static/media/padlock-check.388cce667c4cb914502902b6481fa05c.svg";
export { ForwardRef as ReactComponent };